import http from '@/services/http'
import { taskUrl } from '../../url'
import type * as Types from './type'
import { businessTimezoneTranslate, formatInTimezoneByKeys } from '../businessTimezone'

interface IOrderSync {
  source: string
  storeIds: string[]
  startTime?: number
  endTime?: number
  orderMcIds?: string[]
}

/**
 * 同步订单
 * @param data
 * @returns
 */
export const postOrderSync = businessTimezoneTranslate(
  (data: IOrderSync): Promise<any> => http.admin.post('/api/tasks/order-sync', data, { toast: true }),
  ['startTime', 'endTime'],
  []
)

const exportTimezoneInKeys = {
  // 入库模块
  inbound_order_export: ['startTime', 'endTime'],
  // 订单模块
  order_export: [
    'createStartTime',
    'createEndTime',
    'outboundStartTime',
    'outboundEndTime',
    'platformCreateStartTime',
    'platformCreateEndTime',
    'shipmentEndTime',
    'shipmentStartTime',
    'pushEndTime',
    'pushStartTime',
    'cancelEndTime',
    'cancelStartTime',
    'handUpEndTime',
    'handUpStartTime',
  ],
  // 退货模块
  refund_order_export: ['createEndTime', 'createStartTime'],
  // 库存模块
  stock_flow_page_export: ['startTime', 'endTime'],
  // 短信
  subscription_sms_export: ['createStartTime', 'createEndTime'],
} as Record<string, string[]>
/**
 * 列表导出
 */
export const exportList = async (data: Types.ExportListParam) => {
  const inKeys = exportTimezoneInKeys[data.taskType]
  if (inKeys?.length) {
    const newParams = { ...data.params }
    await formatInTimezoneByKeys(newParams, inKeys)
    data = {
      ...data,
      params: newParams,
    }
  }
  return http.admin.post('/api/tasks/export', data, { toast: true })
}

/**批量导入 */
export const batchImport = (data): Promise<any> => http.admin.post(taskUrl.batchImport, data)

/** 查询任务详情 */
export const getTaskDetail = businessTimezoneTranslate((params: Types.TasksGetReq) => http.admin.get<Types.TasksGetRes>('/api/tasks/get', { params }), [], ['data.createTime'])
